import { Component, inject, signal } from '@angular/core';

import { EventManager } from '@app/shared/utils/event-manager';
import { Modal, ModalType } from '@app/shared/models/modal.model';
import { SharedModule } from '@app/shared/shared.module';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ParagraphComponent } from '@app/shared/components/text/p/p.component';

@Component({
  selector: 'slotcom-info-trophies-modal',
  templateUrl: './info-user-trophies-modal.component.html',
  styleUrls: ['./info-user-trophies-modal.component.scss'],
  standalone: true,
  imports: [SharedModule, ParagraphComponent],
})
export class InfoUserTrophiesModalComponent {
  private eventManager = inject(EventManager);

  trophiesInfoModalData = signal(inject<Modal>(MAT_DIALOG_DATA));

  readonly steps = [
    { asset: 'info-trophies-step-1', label: 'home.recurring-ranking.info-modal.tab-1.text' },
    { asset: 'info-trophies-step-2', label: 'home.recurring-ranking.info-modal.tab-2.text-1' },
    { asset: 'info-trophies-step-3', label: 'home.recurring-ranking.info-modal.tab-3.text-2' },
  ];

  closeInfo() {
    this.eventManager.closeModal(new Modal(this.trophiesInfoModalData().id, ModalType.View));
  }
}
